import { publicAxios } from "../../../config/apiConfig";
import {
  GET_ALL_UI_COLOR_FONT_SUCCESS,
  GET_ALL_UI_COLOR_FONT_REQUEST,
  GET_ALL_UI_COLOR_FONT_FAILURE
} from "./ActionType";

export const getAllUIColorFont = () => async (dispatch) => {
  dispatch({ type: GET_ALL_UI_COLOR_FONT_REQUEST });
  try {
    const { data } = await publicAxios.get(`ui_color_fonts`);
    dispatch({ type: GET_ALL_UI_COLOR_FONT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_ALL_UI_COLOR_FONT_FAILURE,
      payload: error.message
    });
  }
};
